<cb-table [loaded]="true" [objectColumns]="columns">
    <tbody cbTableBody>
        @for (specItem of items; track specItem) {
            @if (!specItem.isColourItem) {
                <cb-lot-spec-item-table-row
                    class="tr"
                    [lotSpec]="lotSpec"
                    [mappedItem]="$any(specItem.item)"
                    (itemDeleted)="specItemDeleted.emit($event)"
                    (itemEdited)="specItemEdited.emit($event)"
                ></cb-lot-spec-item-table-row>
            } @else {
                <cb-lot-spec-colour-item-table-row
                    class="tr"
                    [lotSpec]="lotSpec"
                    [mappedItem]="$any(specItem.item)"
                    (itemDeleted)="colourItemDeleted.emit($any($event))"
                    (itemEdited)="colourItemEdited.emit($event)"
                >
                </cb-lot-spec-colour-item-table-row>
            }
        }
    </tbody>
</cb-table>
